export default "__VITE_ASSET__C_F2xA6h__"